import { qsa } from "../utils/dom"

export const initAnchorAnimations = () => {
  qsa(".ce p a, .footer-nav a, .article-categories a").forEach((a) => {
    const fixedWidth = `${a.offsetWidth * 1.1}px` // fix the width of animated anchors to 110%
    a.style.maxWidth = fixedWidth
    a.style.width = fixedWidth
  })
}
